// In-memory adapter. The default when there's no localStorage (e.g. Node, or a
// privacy-locked browser). Data lives only for the page session.

export class MemoryAdapter {
  constructor() { this.map = new Map(); }
  async get(key) { return this.map.has(key) ? this.map.get(key) : null; }
  async set(key, value) { this.map.set(key, value); }
  async remove(key) { this.map.delete(key); }
}
